import { render } from "./confirm-decline.vue?vue&type=template&id=972ce4e6"
import script from "./confirm-decline.vue?vue&type=script&lang=js"
export * from "./confirm-decline.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__